import AssociationInformation from './AssociationInformation.page';

export default AssociationInformation;